import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import catalogSaga from "./catalogItems/saga"
import departmentSaga from "./Departments/saga"
import categorySaga from "./Categories/saga"
import shiftSaga from "./Shifts/saga"
import teamSaga from "./Teams/saga"
import teamUnAvailabilitySaga from "./TeamUnAvailability/saga"
import checklistSaga from "./Checklists/saga"
import workOrderItemSaga from "./WorkOrderItems/saga"
import CancellationSaga from "./Cancellation/saga"
import NotificationSaga from "./Notification/saga"
import TeamMemberSaga from "./TeamMembers/saga"
import FeedBackSaga from "./feedbacks/saga"
import UserSaga from "./Users/saga"
import CustomerSaga from "./Customers/saga"
import PermissionSaga from "./Permissions/saga"
import Roles from "./Roles/saga"
import AddressSaga from "./Address/saga"
import WorkOrderSaga from "./WorkOrders/saga"
import HolidaySaga from "./Holidays/saga"
import BranchSaga from "./branch/saga"
import SiteSurveySaga from "./SiteSurvey/saga"
import SolutionSaga from "./solutions/saga"
import SebelSaga from "./sebelUsers/saga"
import ZoneSaga from "./Zones/saga"
import AreaSaga from "./Areas/saga"

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    catalogSaga(),
    departmentSaga(),
    categorySaga(),
    shiftSaga(),
    teamSaga(),
    teamUnAvailabilitySaga(),
    checklistSaga(),
    workOrderItemSaga(),
    CancellationSaga(),
    NotificationSaga(),
    TeamMemberSaga(),
    FeedBackSaga(),
    UserSaga(),
    CustomerSaga(),
    PermissionSaga(),
    Roles(),
    AddressSaga(),
    WorkOrderSaga(),
    HolidaySaga(),
    BranchSaga(),
    SiteSurveySaga(),
    SolutionSaga(),
    SebelSaga(),
    ZoneSaga(),
    AreaSaga()
  ])
}
